import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../api/api";
import { toast } from "react-toastify";


export const DeliverySetup = () => {
  const navigate = useNavigate();

  // form state
  const [address, setAddress] = useState("");
  const [method, setMethod] = useState("");
  const [area, setArea] = useState("");
  const [eta, setEta] = useState("");

  const [track, setTrack] = useState(true);

  const [returnsEnabled, setReturnsEnabled] = useState(false);
  const [fullRefundDays, setFullRefundDays] = useState("7");
  const [partialRefundDays, setPartialRefundDays] = useState("14");
  const [returnMethod, setReturnMethod] = useState("");

  const [condUnopened, setCondUnopened] = useState(false);
  const [condTag, setCondTag] = useState(false);
  const [condReceipt, setCondReceipt] = useState(false);

  const [restockingFee, setRestockingFee] = useState("0");

    useEffect(() => {
    (async () => {
      try {
        const data = await api.delivery.getMy();
        if (data) {
          setAddress(data.businessAddress || "");
          setMethod(data.deliveryMethod || "");
          setArea(data.deliveryArea || "");
          setEta(data.eta || "");
          setTrack(!!data.trackingEnabled);
          setReturnsEnabled(!!data.returnsEnabled);
          setFullRefundDays(String(data.fullRefundDays ?? "7"));
          setPartialRefundDays(String(data.partialRefundDays ?? "14"));
          setReturnMethod(data.returnMethod || "");
          setCondUnopened(!!data.condUnopened);
          setCondTag(!!data.condOriginalTag);
          setCondReceipt(!!data.condReceipt);
          setRestockingFee(String(data.restockingFeePct ?? "0"));
        }
      } catch {}
    })();
  }, []);

  const save = async () => {
    try {
      await api.delivery.save({
        businessAddress: address,
        deliveryMethod: method,
        deliveryArea: area,
        eta,
        trackingEnabled: track,
        returnsEnabled,
        fullRefundDays: Number(fullRefundDays || 7),
        partialRefundDays: Number(partialRefundDays || 14),
        returnMethod,
        condUnopened,
        condOriginalTag: condTag,
        condReceipt,
        restockingFeePct: Number(restockingFee || 0),
      });
      toast.success("Delivery settings saved");
      navigate("/dashboard");
    } catch (e) {
      toast.error(e?.data?.message || e.message || "Failed to save");
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[#fff8e1]">
      <div className="app-container [font-family:'Nunito',Helvetica] text-[#5d4037] pb-20">

        {/* Top bar */}
        <div className="w-full flex items-center mt-4">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="ml-4 w-9 h-9 rounded-full bg-[#ccb357] grid place-items-center"
            aria-label="Back"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" stroke="#5d4037" strokeWidth="2" viewBox="0 0 24 24">
              <path d="M15 18l-6-6 6-6" />
            </svg>
          </button>
          <h1 className="flex-1 text-center font-bold text-[18px]">Delivery Setup</h1>
          <div className="w-9" />
        </div>

        {/* Subtitle */}
        <p className="mt-2 px-4 text-[14px]">
          Set up delivery to start fulfilling customer orders.
        </p>

        {/* Section: DELIVERY DETAILS */}
        <div className="px-4 mt-4">
          <p className="font-extrabold uppercase text-[13px] tracking-wide">Delivery Details</p>

          {/* Business Address */}
          <label className="block mt-3 text-base font-semibold mb-2">Business Address</label>
          <input
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            placeholder="Address"
            className="w-full h-[48px] bg-[#fff8e1] rounded-[12px] border border-[#5d4037] px-3 text-[#7a6f5c] outline-none"
            type="text"
          />

          {/* Delivery Method */}
          <label className="block mt-4 text-base font-semibold mb-2">Delivery Method</label>
          <div className="relative">
            <select
              value={method}
              onChange={(e) => setMethod(e.target.value)}
              className="appearance-none w-full h-[48px] bg-[#fff8e1] rounded-[12px] border border-[#5d4037] pl-3 pr-10 text-[#7a6f5c] outline-none"
            >
              <option value="">Standard Delivery</option>
              <option value="Standard Delivery">Standard Delivery</option>
              <option value="Express Delivery">Express Delivery</option>
              <option value="Pickup">Pickup</option>
            </select>
            <div className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" stroke="#5d4037" strokeWidth="2" viewBox="0 0 24 24">
                <path d="M6 9l6 6 6-6" />
              </svg>
            </div>
          </div>

          {/* Delivery Area */}
          <label className="block mt-4 text-base font-semibold mb-2">Delivery Area</label>
          <div className="relative">
            <select
              value={area}
              onChange={(e) => setArea(e.target.value)}
              className="appearance-none w-full h-[48px] bg-[#fff8e1] rounded-[12px] border border-[#5d4037] pl-3 pr-10 text-[#7a6f5c] outline-none"
            >
              <option value="">Uyo, AkwaIbom</option>
              <option value="Uyo, AkwaIbom">Uyo, AkwaIbom</option>
              <option value="Lagos">Lagos</option>
              <option value="Abuja">Abuja</option>
            </select>
            <div className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" stroke="#5d4037" strokeWidth="2" viewBox="0 0 24 24">
                <path d="M6 9l6 6 6-6" />
              </svg>
            </div>
          </div>

          {/* Delivery Time Est */}
          <label className="block mt-4 text-base font-semibold mb-2">Delivery Time Est</label>
          <div className="relative">
            <select
              value={eta}
              onChange={(e) => setEta(e.target.value)}
              className="appearance-none w-full h-[48px] bg-[#fff8e1] rounded-[12px] border border-[#5d4037] pl-3 pr-10 text-[#7a6f5c] outline-none"
            >
              <option value="">3-5 days</option>
              <option value="Same Day">Same Day</option>
              <option value="1-2 days">1-2 days</option>
              <option value="3-5 days">3-5 days</option>
              <option value="5-7 days">5-7 days</option>
            </select>
            <div className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" stroke="#5d4037" strokeWidth="2" viewBox="0 0 24 24">
                <path d="M6 9l6 6 6-6" />
              </svg>
            </div>
          </div>

          {/* Enable Order Tracking */}
          <div className="mt-5">
            <div className="flex items-center justify-between">
              <p className="text-base font-semibold">Enable Order Tracking</p>
              <button
                type="button"
                onClick={() => setTrack((v) => !v)}
                className={`relative w-11 h-6 rounded-full transition-colors ${track ? "bg-[#5d4037]" : "bg-[#e8dcb7]"}`}
                aria-label="Toggle tracking"
              >
                <span className={`absolute top-1 left-1 w-4 h-4 rounded-full bg-white shadow transition-transform ${track ? "translate-x-5" : ""}`} />
              </button>
            </div>
            <p className="text-[12px] text-[#5d4037]/80 mt-1">
              Allow customers to receive delivery details via SMS/Email
            </p>
          </div>
        </div>

        {/* Section: RETURN RULES CONFIGURATION */}
        <div className="px-4 mt-6">
          <p className="font-extrabold uppercase text-[13px] tracking-wide">Return Rules Configuration</p>

          {/* Enable Returns */}
          <div className="mt-3 flex items-center justify-between">
            <p className="text-base font-semibold">Enable Returns</p>
            <button
              type="button"
              onClick={() => setReturnsEnabled((v) => !v)}
              className={`relative w-11 h-6 rounded-full transition-colors ${returnsEnabled ? "bg-[#5d4037]" : "bg-[#e8dcb7]"}`}
              aria-label="Toggle returns"
            >
              <span className={`absolute top-1 left-1 w-4 h-4 rounded-full bg-white shadow transition-transform ${returnsEnabled ? "translate-x-5" : ""}`} />
            </button>
          </div>

          {/* Return Window (Days) */}
          <p className="mt-4 text-[14px] font-semibold">Return Window (Days)</p>
          <div className="mt-2 grid grid-cols-2 gap-3">
            <div>
              <p className="text-[12px] mb-1">Full Refund Window</p>
              <input
                value={fullRefundDays}
                onChange={(e) => setFullRefundDays(e.target.value)}
                placeholder="7"
                className="w-full h-[40px] bg-[#fff8e1] rounded-[12px] border border-[#5d4037] px-3 text-[#7a6f5c] outline-none"
                type="text"
                inputMode="numeric"
              />
            </div>
            <div>
              <p className="text-[12px] mb-1">Partial Refund Window</p>
              <input
                value={partialRefundDays}
                onChange={(e) => setPartialRefundDays(e.target.value)}
                placeholder="14"
                className="w-full h-[40px] bg-[#fff8e1] rounded-[12px] border border-[#5d4037] px-3 text-[#7a6f5c] outline-none"
                type="text"
                inputMode="numeric"
              />
            </div>
          </div>

          {/* Return Method */}
          <label className="block mt-4 text-base font-semibold mb-2">Return Method</label>
          <div className="relative">
            <select
              value={returnMethod}
              onChange={(e) => setReturnMethod(e.target.value)}
              className="appearance-none w-full h-[48px] bg-[#fff8e1] rounded-[12px] border border-[#5d4037] pl-3 pr-10 text-[#7a6f5c] outline-none"
            >
              <option value="">Original payment method</option>
              <option value="Original payment method">Original payment method</option>
              <option value="Store credit">Store credit</option>
              <option value="Exchange">Exchange</option>
            </select>
            <div className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" stroke="#5d4037" strokeWidth="2" viewBox="0 0 24 24">
                <path d="M6 9l6 6 6-6" />
              </svg>
            </div>
          </div>

          {/* Return Conditions */}
          <p className="mt-5 text-base font-semibold">Return Conditions</p>
          <div className="mt-2 space-y-3">
            {/* Unopened Package */}
            <div className="flex items-center justify-between">
              <span>Unopened Package</span>
              <button
                type="button"
                onClick={() => setCondUnopened((v) => !v)}
                className={`relative w-11 h-6 rounded-full transition-colors ${condUnopened ? "bg-[#5d4037]" : "bg-[#e8dcb7]"}`}
                aria-label="Toggle unopened"
              >
                <span className={`absolute top-1 left-1 w-4 h-4 rounded-full bg-white shadow transition-transform ${condUnopened ? "translate-x-5" : ""}`} />
              </button>
            </div>

            {/* Original Tag */}
            <div className="flex items-center justify-between">
              <span>Original Tag</span>
              <button
                type="button"
                onClick={() => setCondTag((v) => !v)}
                className={`relative w-11 h-6 rounded-full transition-colors ${condTag ? "bg-[#5d4037]" : "bg-[#e8dcb7]"}`}
                aria-label="Toggle original tag"
              >
                <span className={`absolute top-1 left-1 w-4 h-4 rounded-full bg-white shadow transition-transform ${condTag ? "translate-x-5" : ""}`} />
              </button>
            </div>

            {/* Original Receipt */}
            <div className="flex items-center justify-between">
              <span>Original Receipt</span>
              <button
                type="button"
                onClick={() => setCondReceipt((v) => !v)}
                className={`relative w-11 h-6 rounded-full transition-colors ${condReceipt ? "bg-[#5d4037]" : "bg-[#e8dcb7]"}`}
                aria-label="Toggle receipt"
              >
                <span className={`absolute top-1 left-1 w-4 h-4 rounded-full bg-white shadow transition-transform ${condReceipt ? "translate-x-5" : ""}`} />
              </button>
            </div>
          </div>

          {/* Restocking Fee */}
          <label className="block mt-4 text-base font-semibold mb-2">Restocking Fee(%)</label>
          <input
            value={restockingFee}
            onChange={(e) => setRestockingFee(e.target.value)}
            placeholder="0"
            className="w-full h-[44px] bg-[#fff8e1] rounded-[12px] border border-[#5d4037] px-3 text-[#7a6f5c] outline-none"
            type="text"
            inputMode="decimal"
          />

          {/* Save / Cancel */}
          <div className="mt-5 flex flex-col items-center">
            <button
              type="button"
              onClick={save} 
             
              className="w-[210px] h-[48px] rounded-[24px] bg-[#f7c945] font-semibold text-[#5d4037] hover:opacity-90 transition-opacity"
            >
              Save Return Rules
            </button>

            <button type="button" onClick={() => navigate(-1)} className="mt-3 text-[#c34040] underline">
              Cancel
            </button>
          </div>
        </div>

        {/* Bottom safe-area bar */}
        <div className="fixed bottom-3 md:bottom-6 left-1/2 -translate-x-1/2 w-full max-w-[1440px] xl:max-w-[1600px] px-6 md:px-10 xl:px-16">
          <div className="h-[22px] bg-[#5d4037] flex items-center justify-center">
            <div className="w-[120px] h-[6px] rounded-full bg-white" />
          </div>
        </div>
      </div>
    </div>
  );
};
